/**
 * Common constants file for configuration
 */
export const stage = process.env.NODE_ENV === 'production' ? 'beta' : 'alpha';
export const region = process.env.NODE_ENV === 'production' ? 'us-west-2' : 'us-west-2';
export const apiEndpoint = `api.${stage}.${region}.devicefarm.ds2.amazon.dev`; //api domain
export const permissionValidate = `https://${apiEndpoint}/permission-validate`;
export const deviceRegistry = `https://${apiEndpoint}/device-registry/device-registry/`;
export const sev2Monitor = `https://${apiEndpoint}/sev2-monitor`;
export const apiTokenManager = `https://${apiEndpoint}/api-token-manager`;
export const assetManagement = `https://${apiEndpoint}/asset-management`;
export const botManagement = `https://${apiEndpoint}/bot-management`;
export const labManagement = `https://${apiEndpoint}/lab-management`;
export const llmService = `https://${apiEndpoint}/llm-service`;
export const supportedRegions = ['us-west-2', 'ap-south-1', 'us-east-2'];
export const regionalAPIs = [
    {
        name: 'v1/group-management',
        route: 'group-management',
    },
    {
        name: 'v1/automation-api',
        route: 'automation-admin',
    },
    {
        name: 'v1/device-registry',
        route: 'device-registry/device-registry/',
    },
    {
        name: 'v1/device-configs',
        route: 'lab-management',
    },
    {
        name: 'v1/reservation-queue',
        route: 'reservation-queue',
    },
];
/**
 * De-couple the dependency between backend and frontend stack by removing the api export and import reference because
 * 1. custom domain for api endpoint is unlikely to be changed
 * 2. if root resource gets changed in the backend, it is easier to update both in backend and frontend stack without the efforts of creating new export name in the backend. but please make sure resource matches here https://code.amazon.com/packages/DeviceFarmCDK/blobs/67ca727bc7c90a2311a480141b5cd97dd50409ab/--/lib/constants/apiMappingConstants.ts
 * 3. references are commented in both places to avoid any missings
 */
export const apiEndpointsConfig = [
    {
        name: 'v2/permission-validate',
        endpoint: permissionValidate,
        region: region,
    },
    {
        name: 'v1/sev2-monitor',
        endpoint: sev2Monitor,
        region: region,
    },
    {
        name: 'v2/api-token-manager',
        endpoint: apiTokenManager,
        region: region,
    },
    {
        name: 'v1/asset-management',
        endpoint: assetManagement,
        region: region,
    },
    {
        name: 'v1/bot-management',
        endpoint: botManagement,
        region: region,
    },
    {
        name: 'v1/lab-management',
        endpoint: labManagement,
        region: region,
    },
    {
        name: 'v1/llm-service',
        endpoint: llmService,
        region: region,
    },
];

/**
 * Module to prepare regionalized APIs and add to endpoint config
 */
supportedRegions.forEach((region) => {
    regionalAPIs.forEach((api) => {
        apiEndpointsConfig.push({
            name: `${region}/${api.name}`,
            endpoint: `https://api.${stage}.${region}.devicefarm.ds2.amazon.dev/${api.route}`,
            region: region,
        });
    });
});
